export const addLog = () => {
    fetch(`/log/`);
};
export const logError = (err, info = { componentStack: '' }) => {
    console.error(err);
    if (info.componentStack)
        console.error(info.componentStack);
};
